import React, { useState, useRef } from 'react';
import { QuantitySelectorContainer, QuantityButton, IconContainer, QuantityInput } from './QuantitySelector.styles.js';
import { Icons } from '@citygross/icons';

function QuantitySelector(_a) {
  var onAdd = _a.onAdd,
      onSubtract = _a.onSubtract,
      _onChange = _a.onChange,
      maxValue = _a.maxValue,
      value = _a.value,
      _onBlur = _a.onBlur;

  var _b = useState(false),
      customFocus = _b[0],
      setCustomFocus = _b[1];

  var inputRef = useRef(null);
  return React.createElement(QuantitySelectorContainer, null, React.createElement(QuantityButton, {
    direction: "left",
    disabled: value <= 0,
    onClick: onSubtract,
    tabIndex: -1
  }, React.createElement(IconContainer, null, React.createElement(Icons.Minus, {
    width: 16,
    height: 16
  }))), React.createElement(QuantityInput, {
    customFocus: customFocus,
    max: maxValue,
    value: value,
    ref: inputRef,
    type: "number",
    pattern: "[0-9]*",
    onMouseDown: function onMouseDown() {
      setCustomFocus(true);
    },
    onClick: function onClick() {
      if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
        inputRef.current.select();
      }
    },
    onFocus: function onFocus() {
      if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
        inputRef.current.select();
      }
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === ',' || event.key === '.') {
        event.preventDefault();
      }

      if (event.key === 'Enter' || event.key === 'Escape') {
        event.currentTarget.blur();
      }
    },
    onBlur: function onBlur() {
      _onBlur && _onBlur();
      setCustomFocus(false);
    },
    onChange: function onChange(e) {
      console.log(e.target.value);

      _onChange(e);
    }
  }), React.createElement(QuantityButton, {
    direction: "right",
    disabled: value >= maxValue,
    onClick: onAdd,
    tabIndex: -1
  }, React.createElement(IconContainer, null, React.createElement(Icons.Plus, {
    width: 16,
    height: 16
  }))));
}

export { QuantitySelector };